import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const e = "administrative-areas";
class A extends a {
  /**
   * Retrieves the list of administrative areas for a given country.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/administrative-areas?{params}`
   *
   * @param {AdministrativeAreasParams} params - The parameters to the request, including the country code.
   * @returns {Promise<AdministrativeAreasResponse>} A promise resolving to the list of administrative areas.
   */
  getAdministrativeAreas = async (s) => {
    const { data: t } = await this.get(
      e,
      s
    );
    return t;
  };
}
export {
  A as AdministrativeAreas
};
